import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ObjectTypes } from '@fi-app/shared/types';
import { FiDocumentTemplateItemOptionsBase } from '../document-template-item-options-base';
import { FiReplaceLinkTypes } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.directive';

@Component({
    selector: 'fi-document-template-item-options-advanced-text',
    templateUrl: './document-template-item-options-advanced-text.component.html',
    styleUrl: './document-template-item-options-advanced-text.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-template-item-options-advanced-text' },
    standalone: false,
})
export class FiDocumentTemplateItemOptionsAdvancedTextComponent extends FiDocumentTemplateItemOptionsBase {
    @Input() replaceLinkTypes = [FiReplaceLinkTypes.Url, FiReplaceLinkTypes.Email];
    ObjectTypes = ObjectTypes;
}
